import React, { createContext, useContext, useEffect, useRef } from 'react';
  
const ScrollContext = createContext(null);
  
const noop = () => {};

export const useScrollToBottom = () => {
    const ctx = useContext(ScrollContext);
    // Used both inside the scrollable chat list and in the standalone loader
    // slot (which has no provider) - fall back to a no-op there.
    return ctx ? ctx.scrollToBottom : noop;
};
  

const ScrollToBottom = ({ children, className, mode = 'bottom', initialScrollBehavior = 'auto'}) => {
    const containerRef = useRef(null);
    const isStickyRef = useRef(true);
  
    const scrollToBottom = () => {
      const el = containerRef.current;
      if (!el) return;
  
      el.scrollTo({
        top: mode === 'top' ? 0 : el.scrollHeight,
        behavior: initialScrollBehavior
      });
    };
  
    useEffect(() => {
      const el = containerRef.current;
      if (!el) return;
  
      const onScroll = () => {
        const threshold = 50;
        const atBottom =
          el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
  
        isStickyRef.current = atBottom;
      };
  
      el.addEventListener('scroll', onScroll);
      return () => el.removeEventListener('scroll', onScroll);
    }, []);
  
    useEffect(() => {
      scrollToBottom();
    }, []);
  
    return (
      <ScrollContext.Provider
        value={{
          scrollToBottom,
          isStickyRef
        }}
      >
        <div ref={containerRef} className={className}>
          {children}
        </div>
      </ScrollContext.Provider>
    );
};
  
export default ScrollToBottom;